import { Visitor } from './interfaces'
import { CatalogNode } from '../CatalogNode'

export class SelectVisitor implements Visitor {
  public visit(node: CatalogNode): void {
    node.select()
  }
}
